module.exports = __webpack_public_path__ + "mk.svg?12c1fffa458d1051841446e12b5f6ae8";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/mk.svg
// module id = 1497
// module chunks = 0